import { useMemo, useState } from "react"
import { createContext } from "use-context-selector"

type SetterArgs = boolean | ((x: boolean) => boolean)
type Setter = (val: SetterArgs) => void

export interface OverlayContextType {
  socialOverlay: boolean
  calendarOverlay: boolean
  setSocialOverlay: Setter
  setCalendarOverlay: Setter
}

export const OverlayContext = createContext<OverlayContextType>({} as any)

type OverlayTypes = "social" | "calendar" | null

export const OverlayContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [overlay, setOverlay] = useState<OverlayTypes>(null)

  function makeSetterFn(overlayType: OverlayTypes) {
    return (val: SetterArgs) => {
      if (typeof val === "function") {
        setOverlay((prevState: OverlayTypes) => {
          if (val(prevState === overlayType)) {
            return overlayType
          }
          return null
        })

        return
      }
      setOverlay(val ? overlayType : null)
    }
  }

  const setCalendarOverlay = useMemo(() => makeSetterFn("calendar"), [])
  const setSocialOverlay = useMemo(() => makeSetterFn("social"), [])
  const socialOverlay = overlay === "social"
  const calendarOverlay = overlay === "calendar"

  return (
    <OverlayContext.Provider
      value={{
        socialOverlay,
        setSocialOverlay,
        calendarOverlay,
        setCalendarOverlay,
      }}
    >
      {children}
    </OverlayContext.Provider>
  )
}
